import React, { useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function Linechart({ heading, Data, xDataKeyName, line1DataKeyName, line2DataKeyName, line3DataKeyName, colorType }) {

    const handleWise = (e, type) => {
        setFilters((prev) => ({
            ...prev,
            [type]: e
        }))
    }
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>


                </div>
                <div style={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: '#fff', border: colorType == "purpleishRed" ? '1px solid #ff7070ff' : "", width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{line1DataKeyName}</h5>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: '#fff', border: colorType == "purpleishRed" ? '1px solid #4fa7c7ff' : "", width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{line2DataKeyName}</h5>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: '#fff', border: colorType == "purpleishRed" ? '1px solid #74529dff' : "", width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{line3DataKeyName}</h5>
                    </div>
                </div>
                <div>
                    {
                        Data?.length > 0 ?

                            <ResponsiveContainer>
                                <LineChart
                                    style={{ width: '100%', maxWidth: '700px', height: '100%', maxHeight: '70vh', aspectRatio: 1.618 }}
                                    responsive
                                    data={Data}
                                    margin={{
                                        top: 5,
                                        right: 0,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey={xDataKeyName} />
                                    <YAxis width="auto" />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey={line1DataKeyName} stroke="#ff7070ff" activeDot={{ r: 2 }} />
                                    <Line type="monotone" dataKey={line2DataKeyName} stroke="#4fa7c7ff" activeDot={{ r: 2 }}/>
                                    <Line type="monotone" dataKey={line3DataKeyName} stroke="#74529dff" activeDot={{ r: 2 }}/>
                                    <RechartsDevtools />
                                </LineChart>
                            </ResponsiveContainer>
                            : ""}
                </div>
            </div>
        </>
    )
}
